import { T } from 'gt-react';
import type { GetPricelistResponse } from '@erp/rpc';
import { PricelistFileActions } from './PricelistFileActions';

export function PricelistCaseSelectedFileActions({
  pricelist,
  onDeleted,
}: {
  pricelist: GetPricelistResponse;
  onDeleted: () => void;
}) {
  return (
    <div className="space-y-2 border-t pt-4">
      <p className="text-xs font-medium tracking-wide text-muted-foreground uppercase">
        <T context="heading above per-file actions on a price change">
          Selected file
        </T>
      </p>
      <p className="truncate text-sm font-medium text-foreground">
        {pricelist.name}
      </p>
      <PricelistFileActions
        key={pricelist.id}
        pricelist={pricelist}
        onDeleted={onDeleted}
        showAssign={false}
      />
    </div>
  );
}
